export var DURATIONS = [5, 10, 15];
export var SkillsCountByTime = {
    5: 1,
    10: 2,
    15: 3,
};
export var DEFAULT_FORM_VALUES = {
    students: [],
    skills: [],
    grade: undefined,
    domain: undefined,
    duration: 10,
    dates: undefined,
    name: undefined,
};
export var UPPER_GRADES_FROM_VALUE = 3;
export var DURATION_RANGES_FOR_UPPER_GRADES = {
    5: {
        start: 5,
        end: 7,
    },
    10: {
        start: 10,
        end: 14,
    },
    15: {
        start: 15,
        end: 20,
    },
};
